/*
  TravBuddies Gratis-Zugaben (Gewinnspiel-Aktion)
  Liegt ein Auslöser-Produkt (Genesis Backpack) im Warenkorb, legt dieses Skript
  je Stück eine Gratis-Zugabe (The Cube, Raincoat) mit der Property _tb_gift dazu
  und hält die Menge synchron. Den Preis von 0,00 € setzen die automatischen
  Buy-X-get-Y-Rabatte in Shopify – das Skript sorgt nur für die Warenkorb-Zeilen.
  Konfiguration: window.tbGwp (layout/theme.liquid, Theme-Einstellungen „Gratis-Zugaben“).
*/
(function () {
  const config = window.tbGwp;
  if (!config || !config.triggerProductId || !config.giftVariantIds || !config.giftVariantIds.length) return;

  const GIFT_PROPERTY = config.property || '_tb_gift';
  let running = false;
  let rerun = false;
  // Wird gesetzt, solange ein Rabattcode geprüft wird: Zugaben müssen dafür kurz
  // aus dem Warenkorb, sonst lehnt Shopify den Code als nicht kombinierbar ab.
  let suspended = false;

  function isActive() {
    const now = Date.now();
    if (config.startsAt && now < config.startsAt) return false;
    if (config.endsAt && now > config.endsAt) return false;
    return true;
  }

  function isGiftLine(item) {
    return item.properties && item.properties[GIFT_PROPERTY];
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  }

  // Gleicht die Zugaben-Zeilen mit der Anzahl der Auslöser-Produkte ab.
  // Liefert true, wenn der Warenkorb geändert wurde.
  async function syncCart() {
    const cart = await fetch(`${window.routes.cart_url}.js`).then((response) => response.json());

    // Rabattcodes sind nicht mit der Zugaben-Aktion kombinierbar: Code schlaegt Zugaben.
    const hasDiscountCode = (cart.discount_codes || []).some((entry) => entry.applicable);

    const triggerQuantity = isActive() && !hasDiscountCode && !suspended
      ? cart.items
          .filter((item) => item.product_id === config.triggerProductId && !isGiftLine(item))
          .reduce((sum, item) => sum + item.quantity, 0)
      : 0;

    const updates = {};
    const additions = [];

    config.giftVariantIds.forEach((variantId) => {
      const giftLines = cart.items.filter((item) => item.variant_id === variantId && isGiftLine(item));
      if (giftLines.length === 0) {
        if (triggerQuantity > 0) {
          additions.push({ id: variantId, quantity: triggerQuantity, properties: { [GIFT_PROPERTY]: '1' } });
        }
        return;
      }
      giftLines.forEach((line, index) => {
        const target = index === 0 ? triggerQuantity : 0;
        if (line.quantity !== target) updates[line.key] = target;
      });
    });

    let changed = false;
    if (Object.keys(updates).length) {
      await postJSON(`${window.routes.cart_update_url}.js`, { updates });
      changed = true;
    }
    if (additions.length) {
      // Zuerst alle Zugaben in einem Request – spart pro Zugabe einen Round-Trip.
      const batch = await postJSON(`${window.routes.cart_add_url}.js`, { items: additions });
      if (batch && batch.status) {
        // Der Sammel-Request scheitert komplett, sobald eine Zugabe ausverkauft ist.
        // Dann einzeln, damit die übrigen trotzdem im Warenkorb landen.
        for (const addition of additions) {
          const result = await postJSON(`${window.routes.cart_add_url}.js`, { items: [addition] });
          if (result && result.status) {
            console.warn('[tb-gwp] Zugabe konnte nicht hinzugefügt werden:', addition.id, result.description);
          } else {
            changed = true;
          }
        }
      } else {
        changed = true;
      }
    }
    return changed;
  }

  // Dawn markiert den leeren Warenkorb per Klasse. Nach unserem eigenen Neuaufbau
  // muss das nachgezogen werden, sonst bleibt der Drawer leer und weiß.
  function markEmptyState(isEmpty) {
    ['cart-drawer', 'cart-drawer-items', 'cart-items'].forEach((selector) => {
      document.querySelector(selector)?.classList.toggle('is-empty', isEmpty);
    });
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
  }

  async function rerender() {
    const drawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');

    const pageSections =
      cartItems && typeof cartItems.getSectionsToRender === 'function' && document.getElementById('main-cart-items')
        ? cartItems.getSectionsToRender()
        : [];
    const drawerSections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : [];
    if (!pageSections.length && !drawerSections.length) return;

    // Warenkorbseite und Drawer in einem einzigen Section-Request holen.
    const ids = [...new Set([...pageSections.map((section) => section.section), ...drawerSections.map((section) => section.id)])];
    const rendered = await fetch(`${window.routes.cart_url}?sections=${ids.join(',')}`).then((r) => r.json());

    pageSections.forEach((section) => {
      const host = document.getElementById(section.id);
      if (!host || !rendered[section.section]) return;
      const target = host.querySelector(section.selector) || host;
      const source = new DOMParser().parseFromString(rendered[section.section], 'text/html').querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });

    // Wie CartDrawer.renderContents, aber ohne den Drawer zu öffnen.
    drawerSections.forEach((section) => {
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target || !rendered[section.id]) return;
      target.innerHTML = drawer.getSectionInnerHTML(rendered[section.id], section.selector);
    });

    if (drawerSections.length) {
      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    }

    const state = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
    markEmptyState(state.item_count === 0);
  }

  async function run(options = {}) {
    if (running) {
      rerun = true;
      return;
    }
    running = true;
    try {
      const changed = await syncCart();
      if (changed || options.forceRender) await rerender();
    } catch (error) {
      console.warn('[tb-gwp]', error);
    } finally {
      running = false;
      if (rerun) {
        rerun = false;
        run();
      }
    }
  }

  // Schnittstelle für die Rabattcode-Eingabe (assets/tb-cart-discount.js).
  window.tbGwpApi = {
    async suspend() {
      suspended = true;
      await run({ forceRender: true });
    },
    async resume() {
      suspended = false;
      await run({ forceRender: true });
    },
  };

  function init() {
    run();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => run());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
